export default "__VITE_ASSET__ccd6e87e__"